// import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SocialMediaLinks from '../../UI/SocialMediaLinks/SocialMediaLinks';
import NavbarElement from './NavbarElement/NavbarElement';
import classes from './Navbar.module.css';
import { parseLocationToPath } from '../../../utils';
import googleAnalytics from '../../../utils/googleAnalytics';

const Navbar = () => {
  const location = useLocation();
  const hub = useSelector((state) => state.hub.hub);
  if (!hub) return null;
  const { sections } = hub;
  const { logo } = hub;
  return (
    <div className={classes.navbar}>
      <div className={classes.infoBar}>
        <div className={classes.logoContainer}>
          <Link to="/">
            <img
              className={classes.imageLogo}
              alt="navLogo"
              src={logo[0].url}
            />
          </Link>
          <a
            href="https://digitaltools.wy.com"
            target="_blank"
            rel="noreferrer"
            className={classes.title}
            onClick={() =>
              googleAnalytics({
                event: 'outboundLink',
                link_url: 'https://digitaltools.wy.com/trusjoist/',
                link_title: 'Content Hub',
                section_title: 'Main',
              })
            }
          >
            CONTENT HUB
          </a>
        </div>
        <SocialMediaLinks />
      </div>
      <div className={classes.navElements}>
        {sections
          .filter(({ name }) => name !== 'Builder Coupon')
          .map(({ link, name, defaultSubsection }) => (
            <NavbarElement
              key={name}
              label={name}
              link={`${link}${
                defaultSubsection !== null ? `/${defaultSubsection}` : ''
              }`}
              selected={parseLocationToPath(location).includes(link)}
            />
          ))}
      </div>
    </div>
  );
};

export default Navbar;
